var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.16 5.34C15.28 0.9 9.39998 -0.42 4.83998 2.34C0.399979 5.1 -1.04002 11.1 1.83998 15.54L2.07998 15.9L1.11998 19.5L4.71998 18.54L5.07998 18.78C6.63998 19.62 8.31998 20.1 9.99998 20.1C11.8 20.1 13.6 19.62 15.16 18.66C19.6 15.78 20.92 9.9 18.16 5.34ZM15.64 14.58C15.16 15.3 14.56 15.78 13.72 15.9C13.24 15.9 12.64 16.14 10.24 15.18C8.19998 14.22 6.51998 12.66 5.31998 10.86C4.59998 10.02 4.23998 8.94 4.11998 7.86C4.11998 6.9 4.47998 6.06 5.07998 5.46C5.31998 5.22 5.55998 5.1 5.79998 5.1H6.39998C6.63998 5.1 6.87998 5.1 6.99998 5.58C7.23998 6.18 7.83998 7.62 7.83998 7.74C7.95998 7.86 7.95998 8.1 7.83998 8.22C7.95998 8.46 7.83998 8.7 7.71998 8.82C7.59998 8.94 7.47998 9.18 7.35998 9.3C7.11998 9.42 6.99998 9.66 7.11998 9.9C7.59998 10.62 8.19998 11.34 8.79998 11.94C9.51998 12.54 10.24 13.02 11.08 13.38C11.32 13.5 11.56 13.5 11.68 13.26C11.8 13.02 12.4 12.42 12.64 12.18C12.88 11.94 13 11.94 13.24 12.06L15.16 13.02C15.4 13.14 15.64 13.26 15.76 13.38C15.88 13.74 15.88 14.22 15.64 14.58Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsApp);
export default __webpack_public_path__ + "static/media/WhatsApp.f5f40256e1276837085e77f8dde5d2d1.svg";
export { ForwardRef as ReactComponent };